import { render, staticRenderFns } from "./ContractItemFormDialog.vue?vue&type=template&id=e135fc7a&"
import script from "./ContractItemFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ContractItemFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports